import {inject, Service} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import {environment} from "../../../environments/environment";
import {SecurityUtils} from "../auth/security.utils";
import {
	MOBILE_DEVICE_EXPORT_LIMIT,
	MobileDevice,
	MobileDeviceFilterValues,
	MobileDeviceTableData,
	MobileDeviceTableDataResponse,
	MobileDeviceTableFilterRequest
} from "./mobile-device.model";

@Service()
export class MobileDeviceService {

	private backendUrl = (tenantId: string) => `${environment.engineURL}/tenants/${tenantId}/mobile-devices`;

	private httpClient = inject(HttpClient);

	/** Devices the MDM saw in the last 30 days. */
	getActiveMobileDeviceCount(tenantId: string): Observable<number> {
		return this.httpClient.get<number>(`${this.backendUrl(tenantId)}/count`, {
			headers: SecurityUtils.getAuthHttpHeaders()
		});
	}

	getFilterValues(tenantId: string): Observable<MobileDeviceFilterValues> {
		return this.httpClient.get<MobileDeviceFilterValues>(`${this.backendUrl(tenantId)}/filters`, {
			headers: SecurityUtils.getAuthHttpHeaders()
		});
	}

	/** The error reaches the list store, which shows it (KAB-2441). */
	getMobileDevicesTableData(tenantId: string, request: MobileDeviceTableFilterRequest): Observable<MobileDeviceTableDataResponse> {
		return this.httpClient.post<MobileDeviceTableDataResponse>(`${this.backendUrl(tenantId)}/table-data`, request, {
			headers: SecurityUtils.getAuthHttpHeaders()
		});
	}

	/** Every device of the fleet, managed or not and whenever last synced, for the settings export. */
	getMobileDeviceExportData(tenantId: string): Observable<MobileDeviceTableData[]> {
		const request: MobileDeviceTableFilterRequest = {
			search: null, type: null, osName: null, manufacturer: null, model: null, isManaged: null, lastSyncWithinDays: 0,
			customFields: null, noValueFilters: null, sortColumn: 'name', sortDirection: 'asc', limit: MOBILE_DEVICE_EXPORT_LIMIT, offset: 0
		};
		return this.getMobileDevicesTableData(tenantId, request).pipe(map(response => response.mobileDevices));
	}

	getMobileDevice(tenantId: string, mobileDeviceId: string): Observable<MobileDevice> {
		return this.httpClient.get<MobileDevice>(`${this.backendUrl(tenantId)}/${mobileDeviceId}`, {
			headers: SecurityUtils.getAuthHttpHeaders()
		});
	}
}
